
import { Component, Vue, Watch } from 'vue-property-decorator';
import SidebarItemLink from '../SidebarItemLink.vue';
import { UserModule } from '@/store/modules/user';
import { AppModule } from '@/store/modules/app';
import {buildPlatformNavigation, navigationMatches, MenuEntry, NavigationItem} from '@/layout/platform-navigation';

@Component({name:'PlatformSidebar',components:{SidebarItemLink}})
export default class extends Vue {
    private opened: string[] = [];

    get isCollapsed() { return !AppModule.sidebar.opened; }

    private toggleGroup(key: string) {
        if (this.isCollapsed) {
            AppModule.ToggleSideBar(false);
            if (!this.opened.includes(key)) this.opened.push(key);
        } else {
            this.opened = this.opened.includes(key) ? this.opened.filter(item => item !== key) : [...this.opened, key];
        }
    }

    get navigation() { return buildPlatformNavigation(UserModule.menuList as unknown as MenuEntry[]); }
    get groups() { return this.navigation.groups; }

    private isActive(item: NavigationItem): boolean {
        const parent = this.$route.meta && this.$route.meta.parentRoute;
        return navigationMatches(item, this.$route.path, parent);
    }

    @Watch('$route.path')
    @Watch('groups', {immediate:true})
    private syncOpenGroup() {
        const active = this.groups.find(group => group.l.some((item:any) => this.isActive(item)));
        this.opened = this.opened.filter(key => this.groups.some(group => group.key === key));
        if (active && !this.opened.includes(active.key)) this.opened.push(active.key);
    }

    mounted() {
        if (!AppModule.sidebar.opened) AppModule.ToggleSideBar(false);
    }
}
